

























import Vue from "vue";
import Component from "vue-class-component";
// mock

@Component({})
export default class Demo extends Vue {
  private navList = [
    {
      index: 0,
      path: "/home",
      title: "首页"
    },
    {
      index: 1,
      path: "/newsCenter",
      title: "新闻中心"
    },
    {
      index: 2,
      path: "/certificateQuery",
      title: "证书查询"
    }
    // {
    //   index: 3,
    //   path: '/annocement',
    //   title: '政策公告',
    // },
    // {
    //   index: 4,
    //   path: '/dataDownload',
    //   title: '资料下载',
    // },
  ];
  private currentPath = "";
  created() {
    this.currentPath = this.$route.path;
  }
  private goNavgater(item) {
    this.currentPath = item.path;
    this.$router.push({ path: item.path });
  }
}
